(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabane-buying-guides"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openLinkedGuide = () => {
      const id = window.location.hash.slice(1);
      if (!id.startsWith('guide-')) return;
      const guide = document.getElementById(id);
      if (!(guide instanceof HTMLDetailsElement) || !guide.classList.contains('cabane-guides__item')) return;
      guide.open = true;
      requestAnimationFrame(() => guide.scrollIntoView({ block: 'start', behavior: 'instant' }));
    };
    window.addEventListener('hashchange', openLinkedGuide);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openLinkedGuide, { once: true });
    else openLinkedGuide();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabane-guide-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-buying-hub]').forEach(root => {
      if (root.dataset.guideEnhanced) return;
      const guides = [...root.querySelectorAll('[data-buying-guide]')];
      const picks = [...root.querySelectorAll('[data-guide-pick]')];
      const list = root.querySelector('[data-guide-tabs]');
      const selector = root.querySelector('[data-guide-select]');
      const compact = matchMedia('(max-width:650px)');
      if (!guides.length) return;
      const componentGroups = [...root.querySelectorAll('[data-guide-component]')];
      const orientComponents = () => componentGroups.forEach(group => {
        const list = group.querySelector('[data-component-tabs]');
        list.setAttribute('aria-orientation','horizontal');
      });
      componentGroups.forEach(group => {
        const list=group.querySelector('[data-component-tabs]');
        const tabs=[...list.querySelectorAll('button')];
        const panels=[...group.querySelectorAll('[data-component-panel]')];
        list.setAttribute('role','tablist');
        list.setAttribute('aria-label',group.closest('section').querySelector('h3')?.textContent || '');
        const activateTab = tab => {
          tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});
          panels.forEach(panel=>{panel.hidden=panel.id!==tab.getAttribute('aria-controls');});
        };
        panels.forEach(panel=>{panel.setAttribute('role','tabpanel');panel.tabIndex=0;});
        tabs.forEach((tab,index)=>{
          tab.setAttribute('role','tab');
          tab.addEventListener('click',()=>activateTab(tab));
          tab.addEventListener('keydown',event=>{
            if(event.ctrlKey||event.metaKey||event.altKey)return;
            const vertical=list.getAttribute('aria-orientation')==='vertical';let next;
            if(event.key===(vertical?'ArrowDown':'ArrowRight'))next=(index+1)%tabs.length;
            else if(event.key===(vertical?'ArrowUp':'ArrowLeft'))next=(index-1+tabs.length)%tabs.length;
            else if(event.key==='Home')next=0;
            else if(event.key==='End')next=tabs.length-1;
            else return;
            event.preventDefault();tabs[next].focus({preventScroll:true});activateTab(tabs[next]);
          });
        });
        activateTab(tabs[0]);
      });
      orientComponents();
      const select = key => {
        const selected = guides.find(guide => guide.dataset.buyingGuide === key);
        if (!selected) return null;
        const situations = root.querySelector('.cabane-buying-hub__situations');
        if (situations) situations.hidden = true;
        const focusWasInPanel = guides.some(guide => guide !== selected && guide.contains(document.activeElement));
        guides.forEach(guide => { guide.hidden = guide !== selected; });
        picks.forEach(pick => {
          const active = pick.dataset.guidePick === key;
          pick.setAttribute('aria-selected', String(active));
          pick.tabIndex = active ? 0 : -1;
        });
        if (selector) selector.value = key;
        if (focusWasInPanel) {
          const focusTarget = compact.matches ? selector : picks.find(pick => pick.dataset.guidePick === key);
          focusTarget?.focus({preventScroll:true});
        }
        return selected;
      };
      const ensureVisible = target => {
        const offset = parseFloat(getComputedStyle(root).getPropertyValue('--guide-offset')) || 180;
        const top = target.getBoundingClientRect().top;
        if (top < offset || top > innerHeight - 140) target.scrollIntoView({block:'start',behavior:'instant'});
      };
      const activate = key => {
        const selected = select(key);
        if (!selected) return;
        const hash = '#' + selected.id;
        if (location.hash !== hash) history.pushState(null,'',hash);
        ensureVisible(selected);
      };
      const fromHash = (scroll = false) => {
        const target = document.getElementById(location.hash.slice(1));
        if (!target || !root.contains(target)) return;
        if (target.matches('[data-buying-guide]')) select(target.dataset.buyingGuide);
        else if (target instanceof HTMLDetailsElement) {
          target.closest('.cabane-buying-hub__situations').hidden = false;
          target.open = true;
        }
        if (scroll) requestAnimationFrame(() => target.scrollIntoView({block:'start',behavior:'instant'}));
      };
      if (list) {
        list.setAttribute('role','tablist');
        list.setAttribute('aria-orientation','vertical');
        picks.forEach((pick,index) => {
          const panel = guides.find(guide => guide.dataset.buyingGuide === pick.dataset.guidePick);
          pick.setAttribute('role','tab');
          pick.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role','tabpanel');
          panel.setAttribute('aria-labelledby',pick.id);
          panel.tabIndex = 0;
          pick.addEventListener('click',event => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            activate(pick.dataset.guidePick);
          });
          pick.addEventListener('keydown',event => {
            if (event.ctrlKey || event.metaKey || event.altKey) return;
            let next;
            if (event.key === 'ArrowDown') next = (index + 1) % picks.length;
            else if (event.key === 'ArrowUp') next = (index - 1 + picks.length) % picks.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = picks.length - 1;
            else if (event.key === ' ') next = index;
            else return;
            event.preventDefault();
            picks[next].focus({preventScroll:true});
            activate(picks[next].dataset.guidePick);
          });
        });
      }
      selector?.addEventListener('change',() => activate(selector.value));
      select(guides[0].dataset.buyingGuide);
      root.dataset.guideEnhanced = 'true';
      const onHashChange = () => fromHash(true);
      const onPopState = () => {
        if (!location.hash) select(guides[0].dataset.buyingGuide);
        else fromHash(true);
      };
      const onResize = () => {
        const selected = guides.find(guide => !guide.hidden);
        if (!selected) return;
        const active = document.activeElement;
        if (compact.matches && picks.includes(active)) selector?.focus({preventScroll:true});
        else if (!compact.matches && active === selector) picks.find(pick => pick.dataset.guidePick === selected.dataset.buyingGuide)?.focus({preventScroll:true});
      };
      window.addEventListener('hashchange',onHashChange);
      window.addEventListener('popstate',onPopState);
      compact.addEventListener('change',onResize);
      const onBlockSelect = event => {
        const panel = event.target.closest('[data-buying-guide]');
        if (panel && root.contains(panel)) { select(panel.dataset.buyingGuide); ensureVisible(panel); }
      };
      document.addEventListener('shopify:block:select',onBlockSelect);
      const onUnload = event => {
        if (!event.target.contains(root)) return;
        window.removeEventListener('hashchange',onHashChange);
        window.removeEventListener('popstate',onPopState);
        compact.removeEventListener('change',onResize);
        document.removeEventListener('shopify:block:select',onBlockSelect);
        document.removeEventListener('shopify:section:unload',onUnload);
      };
      document.addEventListener('shopify:section:unload',onUnload);
      fromHash(true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(),{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabane-guides-immersion"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const gallery = root.querySelector('[data-guide-gallery]');
    const reading = root.querySelector('[data-guide-reading]');
    if (reading) {
      reading.querySelectorAll('[data-guide-product]').forEach(card => {
        const link = card.querySelector('.cabane-card-title-row a');
        const block = card.closest('[data-guide-products]');
        if (!link || !block) return;
        const original = link.href;
        const fields = [['.guide-product__label', 'changedLabel'], ['.guide-product__reason', 'changedReason'], ['.guide-product__stock', 'changedAvailability']].map(([selector, key]) => {
          const node = card.querySelector(selector);
          return {node, key, text: node?.textContent};
        });
        new MutationObserver(() => fields.forEach(({node,key,text}) => {
          if (node) node.textContent = link.href === original ? text : block.dataset[key];
        })).observe(link, {attributes:true, attributeFilter:['href']});
      });
      return;
    }
    if (!gallery) return;
    const categories = JSON.parse(root.querySelector('[data-guide-categories]').textContent);
    const cards = [...gallery.querySelectorAll('[data-guide-card]')];
    const input = gallery.querySelector('[data-search]');
    const normal = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    let category = 'trottinette', need = 'Tous', query = '';
    const filter = () => {
      let total = 0;
      cards.forEach(card => {
        const show = card.dataset.category === category && (need === 'Tous' || card.dataset.need === need) && normal(card.dataset.search || card.textContent).includes(normal(query));
        card.hidden = !show;
        if (show) total++;
      });
      root.querySelectorAll('[data-cat]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.cat === category)));
      root.querySelectorAll('button[data-need]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.need === need)));
      const label = categories.find(c => c.id === category)?.name || '';
      root.querySelector('.result-note').textContent = `${total} guide${total > 1 ? 's' : ''} · ${label}`;
      input.setAttribute('aria-label', 'Rechercher dans les guides ' + label);
      if (input.value !== query) input.value = query;
      root.querySelector('[data-guide-empty]').hidden = total !== 0;
    };
    const route = () => {
      const u = new URL(location.href);
      const oldArticle = location.hash.match(/^#(?:\/)?article\/(.+)$/)?.[1];
      if (oldArticle) {
        const target = cards.find(c => c.dataset.topic === oldArticle);
        if (target) { location.replace(target.href); return; }
      }
      const cat = u.searchParams.get('cat') || location.hash.match(/^#guide-(.+)$/)?.[1];
      if (categories.some(c => c.id === cat)) category = cat;
      filter();
    };
    gallery.addEventListener('submit', event => {
      if (!event.target.matches('.guide-search')) return;
      event.preventDefault(); query = input.value; filter();
    });
    gallery.addEventListener('input', event => { if (event.target === input) {query = input.value; filter();} });
    gallery.addEventListener('click', event => {
      const el = event.target.closest('[data-cat],button[data-need],[data-reset]');
      if (!el) return;
      event.preventDefault();
      if (el.dataset.cat) {
        category = el.dataset.cat; need = 'Tous'; query = '';
        const u = new URL(location.href); u.searchParams.set('cat', category); u.hash = '';
        history.pushState({}, '', u);
      } else if (el.dataset.need) { need = el.dataset.need; query = ''; }
      else { need = 'Tous'; query = ''; }
      filter();
    });
    window.addEventListener('popstate', route);
    window.addEventListener('hashchange', route);
    route();
  };
  document.querySelectorAll('[data-lcg-guides]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-lcg-guides]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-rider-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lcg-rider-grid')) {
  customElements.define('lcg-rider-grid', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => { if (this.isConnected && !this.controller) this.init(); }); }
    init() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.items = [...this.querySelectorAll('.lcg-rider-videos__media > video')].map(video => {
        const media = video.parentElement, card = media.closest('article');
        const item = {video, media, card, preview: false, intent: 0, progress: media.querySelector('input'), status: media.querySelector('[data-inline-status]')};
        video.controls = false;
        video.muted = true;
        media.querySelectorAll('[hidden]').forEach(el => { if (!el.matches('[data-inline-status]')) el.hidden = false; });
        const listen = (el, type, fn) => el.addEventListener(type, fn, {signal});
        media.querySelectorAll('[data-inline-toggle]').forEach(button => listen(button, 'click', () => {
          if (video.paused || (item.preview && button.classList.contains('lcg-inline__surface'))) this.start(item, false);
          else this.stop(item);
        }));
        listen(media.querySelector('[data-inline-mute]'), 'click', () => {
          if (video.paused) this.start(item, false);
          else { item.preview = false; video.loop = false; video.muted = !video.muted; this.sync(item); }
        });
        listen(media.querySelector('[data-inline-fullscreen]'), 'click', async () => {
          try {
            if (document.fullscreenElement) await document.exitFullscreen();
            else if (media.requestFullscreen) await media.requestFullscreen();
            else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
          } catch (_) { this.status(item, 'Plein écran indisponible sur ce navigateur.'); }
        });
        listen(media, 'pointerenter', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
          if (!video.paused && !item.preview) return;
          item.hoverTimer = setTimeout(() => { if (this.isConnected) this.start(item, true); }, 140);
        });
        listen(media, 'pointerleave', () => {
          clearTimeout(item.hoverTimer);
          if (item.preview) this.stop(item);
        });
        listen(item.progress, 'input', () => {
          if (!Number.isFinite(video.duration)) return;
          video.currentTime = video.duration * Number(item.progress.value) / 1000;
          this.sync(item);
        });
        ['play','pause','volumechange','timeupdate','loadedmetadata','durationchange','ended'].forEach(type => listen(video, type, () => this.sync(item)));
        listen(video, 'waiting', () => { if (!video.paused) this.status(item, 'Chargement…'); });
        listen(video, 'playing', () => this.status(item, ''));
        listen(video, 'error', () => this.status(item, 'Vidéo indisponible. Réessaie dans un instant.'));
        this.sync(item);
        return item;
      });
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.intersectionRatio < .25) { const item = this.items.find(item => item.media === entry.target); if (item) this.stop(item); } });
      }, {threshold: [0,.25]});
      this.items.forEach(item => this.observer.observe(item.media));
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.items.forEach(item => this.stop(item)); }, {signal});
      window.addEventListener('pagehide', () => this.items.forEach(item => this.stop(item)), {signal});
      this.classList.add('is-ready');
    }
    async start(item, preview) {
      clearTimeout(item.hoverTimer);
      document.querySelectorAll('lcg-rider-grid').forEach(gallery => gallery.items?.forEach(other => { if (other !== item) gallery.stop(other); }));
      const intent = ++item.intent;
      item.preview = preview;
      item.video.muted = preview;
      item.video.loop = preview;
      this.status(item, '');
      try {
        await item.video.play();
        if (item.intent !== intent) return;
        this.sync(item);
      } catch (error) {
        if (item.intent !== intent || error.name === 'AbortError') return;
        item.preview = false;
        this.sync(item);
        if (!preview) this.status(item, 'Appuie sur lecture pour réessayer.');
      }
    }
    stop(item) {
      clearTimeout(item.hoverTimer);
      item.intent++;
      item.preview = false;
      item.video.pause();
      this.status(item, '');
      this.sync(item);
    }
    status(item, text) { item.status.textContent = text; item.status.hidden = !text; }
    sync(item) {
      const video = item.video, playing = !video.paused;
      item.card.classList.toggle('is-playing', playing);
      item.card.classList.toggle('is-muted', video.muted);
      const rider = item.card.querySelector('.lcg-rider-videos__username').textContent.trim();
      item.media.querySelectorAll('[data-inline-toggle]').forEach(button => {
        const label = item.preview && button.classList.contains('lcg-inline__surface') ? 'Activer le son de la vidéo de ' : playing ? 'Mettre en pause la vidéo de ' : 'Lire la vidéo de ';
        button.setAttribute('aria-label', label + rider);
      });
      const mute = item.media.querySelector('[data-inline-mute]');
      mute.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
      mute.setAttribute('aria-pressed', String(!video.muted));
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      const current = video.currentTime || 0;
      const format = value => Math.floor(value / 60) + ':' + String(Math.floor(value % 60)).padStart(2, '0');
      item.progress.disabled = !duration;
      item.progress.value = duration ? current / duration * 1000 : 0;
      item.progress.style.setProperty('--inline-progress', (duration ? current / duration * 100 : 0) + '%');
      item.progress.setAttribute('aria-valuetext', format(current) + ' sur ' + format(duration));
    }
    disconnectedCallback() {
      this.items?.forEach(item => this.stop(item));
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

  const setupCabaneCatalogFilters = (scope = document) => {

    scope.querySelectorAll('[data-cabane-catalog-root]').forEach((catalog) => {

      const button = catalog.querySelector('[data-cabane-filter-toggle]');

      if (!button || button.dataset.ready === 'true') return;



      const panel = catalog.querySelector('#main-collection-filters');

      const desktopViewport = window.matchMedia('(min-width: 750px)');

      const setFilterState = (isOpen) => {

        const desktopOpen = desktopViewport.matches && isOpen;

        catalog.classList.toggle('is-filters-open', desktopOpen);

        button.setAttribute('aria-expanded', String(desktopOpen));

        if (panel) {

          panel.inert = desktopViewport.matches && !desktopOpen;

          if (desktopViewport.matches) {

            panel.setAttribute('aria-hidden', String(!desktopOpen));

          } else {

            panel.removeAttribute('aria-hidden');

          }

        }

      };



      button.dataset.ready = 'true';

      catalog.classList.add('is-filter-enhanced');

      setFilterState(true);

      button.addEventListener('click', () => {

        setFilterState(!catalog.classList.contains('is-filters-open'));

      });

      desktopViewport.addEventListener('change', (event) => setFilterState(true));

    });

  };



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', () => setupCabaneCatalogFilters(), { once: true });

  } else {

    setupCabaneCatalogFilters();

  }



  document.addEventListener('shopify:section:load', (event) => setupCabaneCatalogFilters(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  const setupCabaneSearchFilters = (scope = document) => {
    scope.querySelectorAll('[data-cabane-catalog-root]').forEach((catalog) => {
      const button = catalog.querySelector('[data-cabane-filter-toggle]');
      if (!button || button.dataset.ready === 'true') return;

      const panel = catalog.querySelector('#main-search-filters');
      const desktopViewport = window.matchMedia('(min-width: 750px)');
      const setFilterState = (isOpen) => {
        const desktopOpen = desktopViewport.matches && isOpen;
        catalog.classList.toggle('is-filters-open', desktopOpen);
        button.setAttribute('aria-expanded', String(desktopOpen));
        if (panel) {
          panel.inert = desktopViewport.matches && !desktopOpen;
          if (desktopViewport.matches) {
            panel.setAttribute('aria-hidden', String(!desktopOpen));
          } else {
            panel.removeAttribute('aria-hidden');
          }
        }
      };

      button.dataset.ready = 'true';
      catalog.classList.add('is-filter-enhanced');
      setFilterState(false);
      button.addEventListener('click', () => {
        setFilterState(!catalog.classList.contains('is-filters-open'));
      });
      desktopViewport.addEventListener('change', () => setFilterState(true));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupCabaneSearchFilters(), { once: true });
  } else {
    setupCabaneSearchFilters();
  }

  document.addEventListener('shopify:section:load', (event) => setupCabaneSearchFilters(event.target));

  } catch(e) { console.error(e); }
})();
})();
